import { userTypes } from './Content';
import retirement from '../../assets/images/icons/BRB-Icons/Retirement.svg';
import bank from '../../assets/images/icons/BRB-Icons/Bank.svg';
import like from '../../assets/images/icons/BRB-Icons/Like.svg';
import planning from '../../assets/images/icons/BRB-Icons/Planning.svg';
import wallet from '../../assets/images/icons/BRB-Icons/Wallet.svg';
import book from '../../assets/images/icons/BRB-Icons/Book.svg';
import { insightsPage, rasLandingPage } from './Links';
import chart from '../../assets/images/icons/BRB-Icons/Chart.svg';
import thinking from '../../assets/images/icons/BRB-Icons/Thinking.svg';

const WANT_HELP_PREPARING_FOR_RETIREMENT = {
  title: `Want help preparing for retirement?`,
  text: `We care about your financial well-being.
                 Talk to one of our Investment Specialists
                today.`,
  buttonText: "Call 1-800-831-1433",
  image: retirement,
  id: "retirement",
  variant: "contained",
  url: "tel:18008311433"
};

const SAVE_FOR_RETIREMENT = {
  title: `Save for retirement in a <span style="white-space: nowrap">T. Rowe Price</span> IRA.`,
  text: `We offer a variety of retirement accounts to
         help you confidently invest and meet your goals.`,
  buttonText: "Learn About IRAs",
  variant: "outlined",
  image: bank,
  id: "bank",
  url:
    "https://www.troweprice.com/personal-investing/accounts/retirement/ira/index.html"
};

const MANAGE_YOUR_SUBSCRIPTIONS = {
  title: `Manage your <span style="white-space: nowrap">T. Rowe Price</span> subscriptions`,
  text: `We offer you a variety of resources.
            Manage your subscriptions to choose
            those most helpful for you. `,
  buttonText: "Manage Subscriptions",
  variant: "outlined",
  image: like,
  id: "like",
  url:
    "https://www3.troweprice.com/aaweb1/myProfile/page/profile-preferences/email-preferences/edit.otc"
};

const LEARN_MORE_ABOUT_PLANNING_FOR_RETIREMENT = {
  title: "Learn more about planning for retirement.",
  text: `Wherever you are in life, we can help you
            plan and save for a more secure financial future.`,
  buttonText: "Explore Planning",
  image: planning,
  id: "planning",
  variant: "outlined",
  url:
    "https://www.troweprice.com/personal-investing/resources/planning/retirement-planning/index.html"
};

const TAKE_TIME_TO_REVIEW_YOUR_CURRENT_ACCOUNTS = {
  title: "Take time to review your current accounts.",
  text: `Now is a great time to review your current
            accounts and consider any updates to your
            portfolio. We're always here to help.`,
  buttonText: "Review My Accounts",
  variant: "outlined",
  image: wallet,
  id: "wallet",
  url: "https://www.troweprice.com/usis/my-accounts/"
};

const CHECK_OUT_INSIGHTS = {
  title: `Check out Insights from <span style="white-space: nowrap">T. Rowe Price</span>.`,
  text: `Gain valuable perspective on retirement planning,
            investing strategies, and personal finance. `,
  buttonText: "Start Reading Today",
  variant: "outlined",
  image: book,
  id: "book",
  url: `${insightsPage}`
};

const ACTIVEPLUS_PORTFOLIOS = {
  title: `<span style="white-space: nowrap">T. Rowe Price</span><sup>&reg;</sup> ActivePlus Portfolios may be for you.`,
  text: `Want digital investing powered by our experts? Get a recommendation for an expertly
            diversified, fully managed portfolio in minutes. `,
  buttonText: "Get Started",
  variant: "outlined",
  image: chart,
  id: "chart",
  url:
    "https://www.troweprice.com/personal-investing/advice/activeplus-portfolios/index.html"
};

const SUBSCRIBE_TO_INSIGHTS = {
  title: `Subscribe to <span style="white-space: nowrap">T. Rowe Price</span> Insights.`,
  text: `Receive articles that provide retirement guidance, financial planning tips and other
            investment topics every month.`,
  buttonText: "Subscribe Today",
  variant: "outlined",
  image: like,
  id: "like",
  url: `${insightsPage}`
};

const VIEW_OUR_ADVICE_AND_PLANNING_SOLUTIONS = {
  title: "View our advice and planning solutions",
  text: `We can help you invest with a plan for retirement, based on our strategic investing approach and advice
            you can trust.`,
  buttonText: "Explore Advice & Planning",
  variant: "outlined",
  image: thinking,
  id: "thinking",
  url: "https://www.troweprice.com/personal-investing/advice/index.html"
};

const GET_ON_TRACK = {
  title: `Get on track. Retirement Advisory Service™ can help.`,
  text: `More than a plan, a guided path to help you stay on track. Get a personalized financial plan with no cost or commitment. 
        Enjoy advisor support and powerful digital tools when you enroll in the discretionary service (min. $250,000).`,
  buttonText: "Explore Retirement Advisory Service",
  variant: "outlined",
  image: retirement,
  id: "ras-cta",
  url: `${rasLandingPage}`
};

export const buildCards = (user, score, assetAmount) => {
  let output = [];
  const RAS_MINIMUM = 250000; //$250,000 is the minimum held assets amount for RAS recommendation

  if (user === userTypes.ANONYMOUS) {
    output.push(WANT_HELP_PREPARING_FOR_RETIREMENT);
    output.push(SAVE_FOR_RETIREMENT);
    output.push(SUBSCRIBE_TO_INSIGHTS);
  } else if (user === userTypes.GUEST) {
    if (assetAmount < RAS_MINIMUM) {
      if (score <= 75) {
        output.push(WANT_HELP_PREPARING_FOR_RETIREMENT);
        output.push(SAVE_FOR_RETIREMENT);
        output.push(LEARN_MORE_ABOUT_PLANNING_FOR_RETIREMENT);
      } else if (score > 75 && score < 96) {
        output.push(WANT_HELP_PREPARING_FOR_RETIREMENT);
        output.push(ACTIVEPLUS_PORTFOLIOS);
        output.push(LEARN_MORE_ABOUT_PLANNING_FOR_RETIREMENT);
      } else {
        output.push(WANT_HELP_PREPARING_FOR_RETIREMENT);
        output.push(ACTIVEPLUS_PORTFOLIOS);
        output.push(CHECK_OUT_INSIGHTS);
      }
    } else {
      if (score <= 75) {
        output.push(GET_ON_TRACK);
        output.push(SAVE_FOR_RETIREMENT);
        output.push(LEARN_MORE_ABOUT_PLANNING_FOR_RETIREMENT);
      } else if (score > 75 && score < 96) {
        output.push(GET_ON_TRACK);
        output.push(ACTIVEPLUS_PORTFOLIOS);
        output.push(LEARN_MORE_ABOUT_PLANNING_FOR_RETIREMENT);
      } else {
        output.push(GET_ON_TRACK);
        output.push(ACTIVEPLUS_PORTFOLIOS);
        output.push(CHECK_OUT_INSIGHTS);
      }
    }
  } else if (user === userTypes.CLIENT) {
    if (assetAmount < RAS_MINIMUM) {
      if (score <= 75) {
        output.push(LEARN_MORE_ABOUT_PLANNING_FOR_RETIREMENT);
        output.push(TAKE_TIME_TO_REVIEW_YOUR_CURRENT_ACCOUNTS);
        output.push(MANAGE_YOUR_SUBSCRIPTIONS);
      } else {
        output.push(LEARN_MORE_ABOUT_PLANNING_FOR_RETIREMENT);
        output.push(VIEW_OUR_ADVICE_AND_PLANNING_SOLUTIONS);
        output.push(MANAGE_YOUR_SUBSCRIPTIONS);
      }
    } else {
      if (score <= 75) {
        output.push(GET_ON_TRACK);
        output.push(LEARN_MORE_ABOUT_PLANNING_FOR_RETIREMENT);
        output.push(TAKE_TIME_TO_REVIEW_YOUR_CURRENT_ACCOUNTS);
      } else {
        output.push(GET_ON_TRACK);
        output.push(LEARN_MORE_ABOUT_PLANNING_FOR_RETIREMENT);
        output.push(MANAGE_YOUR_SUBSCRIPTIONS);
      }
    }
  }
  return output;
};
